import React, { useId } from 'react';
import PropTypes from 'prop-types';

export default function CrisisFeedback({ feedback }) {
    const titleId = useId();
    if (!feedback?.requiresResponse) return null;
    return <article className="review-card feedback-crisis" aria-labelledby={titleId}>
        <div className="review-row"><div><span className="ai-kicker">SAFETY REVIEW</span><h2 id={titleId}>위기 대응 피드백</h2></div><span className="review-tag warm">우선 검토 필요</span></div>
        <div className="feedback-crisis-signal"><strong>{feedback.time} · 위기 신호</strong><p>{feedback.signal}</p></div>
        <section><h3>확인된 대응</h3><p>{feedback.observed}</p></section>
        <section><h3>보완할 대응</h3><p>{feedback.missing}</p></section>
        <div className="review-callout"><strong>다음 연습</strong><p>{feedback.next}</p></div>
        <p className="ai-small">{feedback.note}</p>
    </article>;
}
CrisisFeedback.propTypes = {
    feedback: PropTypes.shape({
        requiresResponse: PropTypes.bool.isRequired,
        time: PropTypes.string, signal: PropTypes.string, observed: PropTypes.string,
        missing: PropTypes.string, next: PropTypes.string, note: PropTypes.string,
    }).isRequired,
};
